"use client";

import { Core } from "@faire/slate/foundation/color";
import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// TODO(alipianu): keep in sync with Figma (synced from https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=1737-494&m=dev)
/** @optimized using svgo:^3.0.2 */
export const Shopify = createSVGIcon(
  <path
    d="M15.862 2.808s-.271.077-.716.213a5.7 5.7 0 0 0-.349-.852C14.294 1.2 13.54.679 12.65.679c-.058 0-.116 0-.194.02-.02-.04-.058-.059-.077-.098-.387-.425-.89-.619-1.49-.6C9.726.04 8.565.872 7.636 2.362 6.978 3.408 6.475 4.724 6.34 5.75c-1.336.407-2.265.697-2.284.716-.678.213-.697.233-.774.871-.117.484-1.878 14.129-1.878 14.129L16.036 24V2.769c-.078.02-.136.02-.174.039m-3.387 1.045c-.774.232-1.626.503-2.458.755.232-.91.697-1.82 1.238-2.42.213-.213.504-.464.833-.619.329.697.406 1.645.387 2.284M10.907.775q.406 0 .697.175c-.31.154-.62.406-.91.696C9.96 2.44 9.397 3.68 9.165 4.86l-2.032.62C7.539 3.638 9.107.833 10.907.774M8.643 11.42c.077 1.239 3.348 1.51 3.541 4.432.136 2.303-1.219 3.87-3.174 3.987-2.36.155-3.658-1.239-3.658-1.239l.504-2.129s1.296.987 2.341.91c.678-.039.93-.6.91-.987-.097-1.626-2.767-1.529-2.942-4.2-.154-2.225 1.316-4.49 4.568-4.703 1.258-.077 1.896.232 1.896.232l-.735 2.787s-.832-.387-1.82-.31c-1.431.098-1.45 1.007-1.431 1.22m4.606-7.8c0-.58-.078-1.412-.349-2.11.89.175 1.316 1.162 1.51 1.762q-.522.146-1.161.348M16.52 23.923l6.077-1.51s-2.613-17.67-2.633-17.786a.225.225 0 0 0-.212-.194c-.097 0-1.8-.038-1.8-.038S16.907 3.388 16.519 3z"
    fill="currentColor"
  />,
  "Shopify",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    titleAccess: strictLocalize({
      id: "z5k00S",
      defaultMessage: "Shopify logo",
      description: { text: "The label for Shopify's company logo icon" },
    }),
  })
);
